import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import * as templatesAPI from '@debbie/cortex/dist/api/templates.js';
import { Button, Modal } from '../../index.js';
import TemplateSearch from './TemplateSearch.js';
const CopyModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const [templates, setTemplates] = useState(null);
    const [loading, setLoading] = useState(false);
    return (React.createElement(Modal, { header: lang.templates.copyOtherTemplate, onToggle: props.toggleModal },
        React.createElement(TemplateSearch, { templateType: props.template.type, selectedTemplate: templates, onChange: async (_templates) => {
                setTemplates(_templates);
            } }),
        React.createElement(Button, { disabled: !templates, loading: loading, onClick: async () => {
                try {
                    setLoading(true);
                    for (let i = 0; i < (templates?.templates.length || 0); i++) {
                        const template = templates?.templates[i];
                        if (!template)
                            continue;
                        await templatesAPI.saveDraft({
                            ...props.template,
                            public: undefined,
                            html: template.html,
                            intent: template.intent,
                            subject: template.subject || '\n',
                            lang: template.lang,
                            templateTheme: template.templateTheme,
                            isForAlternativeContact: template.isForAlternativeContact,
                            fileName: template.fileName,
                            text: template.text,
                            setup: template.setup,
                        });
                    }
                    await props.toggleModal();
                    await props.loadTemplate();
                }
                catch (error) {
                    console.error(error);
                    alert('Error');
                }
                setLoading(false);
            } }, lang.templates.copy)));
};
export default CopyModal;
//# sourceMappingURL=CopyTemplateModal.js.map